import {
  CreateSubscriptionData,
  Subscription,
  SubscriptionStatus,
} from '@models/membership/Subscription'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_SUBSCRIPTIONS_URL } from '@utils/urls'

const fetchSubscriptions = (params: TableParams) =>
  SBAPI.FetchPaginated<Subscription[]>(MEMBERSHIP_SUBSCRIPTIONS_URL, params)

const fetchSubscriptionStatusCounts = () =>
  SBAPI.Fetch<Partial<Record<SubscriptionStatus, number>>>(
    `${MEMBERSHIP_SUBSCRIPTIONS_URL}/status-counts`
  )

const acceptSubscription = (subscriptionId: number) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/accept`, {})

const rejectSubscription = (
  subscriptionId: number,
  reason?: string,
  sendEmail?: boolean
) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/reject`, {
    reason,
    sendEmail,
  })

const confirmSubscriptionTransfer = (subscriptionId: number) =>
  SBAPI.Post(
    `${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/confirm-transfer`,
    {}
  )

const fetchSubscriptionById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Subscription>(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${id}`, params)

const createSubscription = (subscription: CreateSubscriptionData) =>
  SBAPI.Post(MEMBERSHIP_SUBSCRIPTIONS_URL, subscription)

const deleteSubscription = (subscriptionId: number) =>
  SBAPI.Delete(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}`)

const updateTagsForSubscription = (subscriptionId: number, tags: number[]) =>
  SBAPI.Put(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/tags`, {
    tags,
  })

const markSubscriptionToCancel = (id: Subscription['id']) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${id}/mark-to-cancel`)
const cancelSubscription = (id: Subscription['id']) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${id}/cancel`)
const reactivateSubscription = (id: Subscription['id']) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${id}/reactivate`)

const attachCouponToSubscription = (subscriptionId: number, couponId: number) =>
  SBAPI.Post(
    `${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/attach-coupon`,
    { coupon: couponId }
  )

const changeSubscriptionPlan = (subscriptionId: number, planId: number) =>
  SBAPI.Post(`${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/change-plan`, {
    plan: planId,
  })

const detachCouponFromSubscription = (subscriptionId: number) =>
  SBAPI.Post(
    `${MEMBERSHIP_SUBSCRIPTIONS_URL}/${subscriptionId}/detach-coupon`,
    {}
  )

export {
  acceptSubscription,
  attachCouponToSubscription,
  cancelSubscription,
  changeSubscriptionPlan,
  detachCouponFromSubscription,
  confirmSubscriptionTransfer,
  createSubscription,
  deleteSubscription,
  fetchSubscriptionById,
  fetchSubscriptions,
  fetchSubscriptionStatusCounts,
  markSubscriptionToCancel,
  reactivateSubscription,
  rejectSubscription,
  updateTagsForSubscription,
}
